var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-filter"},[_c('div',{staticClass:"project-filter__focus-links"},[_c('nuxt-link',{staticClass:"project-filter__link project-filter__link--neutral",class:{ 'project-filter__link--active': !_vm.$route.query.focus },attrs:{"to":{
        path: _vm.$route.path,
        query: {
          view: _vm.$route.query.view
        }
      }}},[_vm._v("\n      Alle\n    ")]),_vm._v(" "),_vm._l((_vm.allFocusItems),function(focus){return _c('nuxt-link',{key:focus.id,class:[
        'project-filter__link',
        { 'project-filter__link--active': _vm.$route.query.focus === focus.id },
        ("project-filter__link--" + (focus.id))
      ],attrs:{"to":{
        path: _vm.$route.path,
        query: {
          view: _vm.$route.query.view,
          focus: focus.id
        },
      }}},[_vm._v("\n      "+_vm._s(focus.label)+"\n    ")])})],2),_vm._v(" "),_c('div',{staticClass:"project-filter__list-switch"},[_c('nuxt-link',{staticClass:"project-filter__switch",class:{ 'project-filter__switch--active': _vm.$route.query.view !== 'list' },attrs:{"to":{
        query: {
          view: 'grid',
          focus: _vm.$route.query.focus
        }
      }}},[_vm._v("\n      Vorschau\n      "),_c('svgGridView',{staticClass:"project-filter__icon"})],1),_vm._v(" "),_c('nuxt-link',{staticClass:"project-filter__switch",class:{ 'project-filter__switch--active': _vm.$route.query.view === 'list' },attrs:{"to":{
        query: {
          view: 'list',
          focus: _vm.$route.query.focus
        }
      }}},[_vm._v("\n      Liste\n      "),_c('svgListView',{staticClass:"project-filter__icon"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }